

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import './toggle-button.scss';
import { rgba } from "polished";
import styled from "styled-components";
import { useTheme } from 'styled-components';

const StyledProfileToggle = styled.div`
.toggle-button{
	border: 1px solid ${({ theme }) => rgba(theme.primary, 0.6)};
	// border-radius: 10px;
	width:100%;
	color: ${({ theme }) =>theme.primary};
}
    .toggle-button:first-child {
  border-radius: 10px 0px 0px 10px;
}

 .toggle-button:last-child {
   border-radius: 0px 10px 10px 0px !important;
 }
.toggle-button-active{
background-color: ${({ theme }) => rgba(theme.primary, 0.3)};

   &:first-child {
      border-radius: 10px 0px 0px 10px !important;
    }
}

  .toggle-button:hover{
    background-color: ${({ theme }) => rgba(theme.primary, 0.3)};
  }
`;

const StyledToggle = styled.div`
.toggle-button{
	border: 1px solid ${({ theme }) => rgba(theme.primary, 0.6)};
	// border-radius: 10px;
	width:100%;
	color: ${({ theme }) =>theme.primary};
}
.toggle-button-active{
background-color: ${({ theme }) => rgba(theme.primary, 0.3)};
}
  .toggle-button:hover{
    background-color: ${({ theme }) => rgba(theme.primary, 0.3)};
  }
    .toggle-sort{
    border: 1px solid ${({ theme }) => rgba(theme.primary, 0.6)};
    width:100%;
    height:2.5rem;
    background-color: #ffffff;
    color: ${({ theme }) =>theme.primary};
    }
    .toggle-sort-active{
    background-color: ${({ theme }) => rgba(theme.primary, 0.3)};
    }
}
   
`;


const ToggleBtn = ({ isActive, onClick, label, disabled, className, ...restProps }) => {
    const theme = useTheme();
    const inlineBackground = {
        "--bg-color-1": theme.primary,
      };
      const sortBtnActive = restProps.sort && isActive;
      const btnActive = !restProps.sort && isActive;
    return (
        <>
            {restProps.fromProfile ? (
                <StyledProfileToggle style={{ width: "100%" }}>
                    <button
                        className={classNames('toggle-button', className, { 'toggle-button-active': isActive })}
                        onClick={onClick}
                    >
                        {label}
                    </button>
                </StyledProfileToggle>
            ) : (
                <StyledToggle style={{width: restProps.small ?"20%" : "100%" }}  onClick={onClick} >
                    <button
                        className={classNames(restProps.sort? 'toggle-sort':'toggle-button', { 'toggle-sort-active': sortBtnActive },{ 'toggle-button-active': btnActive}, { 'toggle-button-disabled': disabled })}
                        disabled = {disabled}
                        style={inlineBackground}
   
                    >
                        {label}
                    </button>
                </StyledToggle>
            )}
        </>
    );
};

ToggleBtn.propTypes = {
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

const ToggleButtonGroup = ({ options, onChange,value, ...restProps}) => {

    // useEffect(() => {
    //     if(value){
    //     const index = options?.findIndex(option => option.value === value);
    //     if (index !== -1) {
    //         setActiveIndex(index);
    //     }}
    // }, [value, options]);

   

    const handleToggle = (newValue, e) => {
        onChange(newValue, e);
    };
    return (
        <div className="button-group" >
            {options?.map((option, index) => {              
                return <ToggleBtn
                    key={index}
                    isActive={option.value === value}
                    onClick={(e) => {handleToggle(option.value,e)}}
                    label={option.label}
                    disabled = {restProps.disabled && option.value != value}
                    {...restProps}
                />
})}
        </div>
    );
};

ToggleButtonGroup.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    ),
    onChange: PropTypes.func.isRequired,
};

export default ToggleButtonGroup;




